// Configuration des étapes d'optimisation TURPE
export const TURPE_STAGE_CONFIG = {
  onboarding: {
    label: "Intégration",
    color: "text-blue-600",
    progressBarColor: "bg-blue-500",
    baseProgression: 10
  },
  data_collection: {
    label: "Collecte données",
    color: "text-yellow-600",
    progressBarColor: "bg-yellow-500",
    baseProgression: 25
  },
  analysis: {
    label: "Analyse",
    color: "text-purple-600",
    progressBarColor: "bg-purple-500",
    baseProgression: 50
  },
  optimization: {
    label: "Optimisation",
    color: "text-orange-600",
    progressBarColor: "bg-orange-500",
    baseProgression: 75
  },
  implementation: {
    label: "Mise en œuvre",
    color: "text-green-600",
    progressBarColor: "bg-green-500",
    baseProgression: 90
  },
  monitoring: {
    label: "Suivi",
    color: "text-green-600",
    progressBarColor: "bg-green-500",
    baseProgression: 100
  },
  error: {
    label: "Erreur",
    color: "text-red-600",
    progressBarColor: "bg-red-500",
    baseProgression: 0
  },
  default: {
    label: "En cours",
    color: "text-gray-600",
    progressBarColor: "bg-gray-500",
    baseProgression: 0
  }
};